<template>
    <div class="stepper">
        <nav>
            <ul>
                <slot />
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: 'Stepper'
};
</script>
